<template>
  <div class="project-detail" v-if="currentProject">
    <div class="project-detail__main-visual">
      <div class="project-detail__main-visual__content">
        <h2 class="project-visual__title">
          {{ currentProject.fields.title }}
        </h2>
        <gal-image-with-animation
          class="project-detail__main-visual__image"
          :visual="backgroundImage"
          v-on:image-loaded="onImgLoad"
        />
      </div>
    </div>

    <div class="container-fluid container-fluid--medium">
      <div class="project-detail__intro row center-xs">
        <div class="col-xs-10 col-md-7">{{ currentProject.fields.intro }}</div>
      </div>
      <div class="visuals">
        <div
          class="visual"
          v-for="(item, i) in currentProject.fields.visuals"
          :key="i"
        >
          <single-project-visual
            v-if="item.sys.contentType.sys.id === 'singleProjectVisal'"
            :visual="item.fields.visual"
            :clickMethod="showPhotoSwipe"
            :indexVisual="getIndex()"
          />
          <double-project-visual
            v-if="item.sys.contentType.sys.id === 'doubleProjectVisual'"
            :visuals="item.fields"
            :clickMethod="showPhotoSwipe"
            :indexVisual1="getIndex()"
            :indexVisual2="getIndex()"
          />
        </div>
      </div>
    </div>

    <v-photoswipe
      :isOpen="isOpen"
      :items="images"
      :options="options"
      @close="hidePhotoSwipe"
    ></v-photoswipe>

    <gal-cursor></gal-cursor>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import DoubleProjectVisual from '../components/molecules/doubleProjectVisual';
import SingleProjectVisual from '../components/molecules/singleProjectVisual';
import { PhotoSwipe } from 'v-photoswipe';
import GalImageWithAnimation from '../components/atoms/imageWithAnimation';
import GalCursor from '../components/atoms/cursor';

const images = [];
let visualIndex = 0;

function createVisual(visual) {
  const aspectRatio =
    visual.fields.file.details.image.width /
    visual.fields.file.details.image.height;
  images.push({
    src: `${visual.fields.file.url}?w=1110`,
    w: 1110,
    h: 1110 / aspectRatio,
    title: visual.fields.file.description,
  });
}

export default {
  name: 'projectPage',
  components: {
    SingleProjectVisual,
    DoubleProjectVisual,
    'v-photoswipe': PhotoSwipe,
    GalImageWithAnimation,
    GalCursor,
  },
  data() {
    return {
      isOpen: false,
      isOpenGallery: false,
      options: {
        index: 0,
      },
      optionsGallery: {},
    };
  },
  created: function() {
    this.$store.dispatch(
      'setProject',
      this.$route.params.projectSlug.toLowerCase(),
    );
    this.$store.commit('setCursor', false);
  },
  computed: {
    ...mapGetters(['currentProject', 'language']),
    ...mapState(['website']),
    images: function() {
      if (this.currentProject.fields.visuals) {
        for (let i = 0; i < this.currentProject.fields.visuals.length; i++) {
          const visualContainer = this.currentProject.fields.visuals[i];

          if (
            visualContainer.sys.contentType.sys.id === 'doubleProjectVisual'
          ) {
            createVisual(visualContainer.fields.visual1);
            createVisual(visualContainer.fields.visual2);
          } else {
            createVisual(visualContainer.fields.visual);
          }
        }
      }
      return images;
    },
    backgroundImage: function() {
      const width = Math.round(window.innerWidth * 0.79);
      return this.updateImageUrl(
        `${this.currentProject.fields.mainVisual.fields.file.url}?w=${width}`,
      );
    },
  },
  methods: {
    showPhotoSwipe(index) {
      visualIndex = 0;
      this.isOpen = true;
      this.$set(this.options, 'index', index);
    },
    hidePhotoSwipe() {
      visualIndex = 0;
      this.isOpen = false;
    },
    getIndex() {
      const value = visualIndex++;
      return value;
    },
    onImgLoad() {
      this.$store.commit('setHeroIsLoaded', true);
    },
    metaInfo() {
      //check data before using its properties, and when data will be loaded metaInfo will update object as well:
      const currentPage = this.currentProject.fields;
      const website = this.website;

      if (currentPage && website) {
        return {
          title: currentPage ? currentPage.title : '',
          titleTemplate: website ? website.title + ' - %s' : '',
          meta: [
            { charset: 'utf-8' },
            {
              name: 'og:title',
              content: currentPage ? currentPage.title : '',
            },
            {
              name: 'og:description',
              content: currentPage ? currentPage.intro : '',
            },
            {
              name: 'description',
              content: currentPage ? currentPage.intro : '',
            },
            {
              name: 'og:image',
              property: 'og:image',
              content:
                currentPage && currentPage.socialImage
                  ? currentPage.mainVisual.fields.file.url + '?w=1000'
                  : './track.jpg',
            },
          ],
          htmlAttrs: {
            lang: 'en',
            amp: true,
          },
        };
      }
    },
  },
};
</script>
